import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import DisposeRoute from './disposeRoute';

// 懒加载组件
const AlibabaBidList = lazy(() => import('@/views/alibaba'));
const AlibabaBidDetail = lazy(() => import('@/views/alibaba/detail'));

// 阿里巴巴竞价列表路由配置
export const alibabaRoutes: RouteObject[] = [
  {
    path: '/alibaba',
    element: (
      <DisposeRoute
        element={<AlibabaBidList />}
        titleId='web.menu.alibaba'
        auth
      />
    ),
  },
  {
    path: '/alibaba/detail/:id',
    element: (
      <DisposeRoute
        element={<AlibabaBidDetail />}
        titleId='web.alibaba.detail.title'
        auth
      />
    ),
  },
];
